<ng-container *ngIf="applistType == UI_APPLIST_TYPE.agactive">
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title class="text-nowrap">
                <mat-icon class="mat-icon-middle material-symbols-outlined mat-icon-size-1">person</mat-icon>
                <a class="btn">
                    <span class="body-title me-3">{{item.firstName}} {{item.lastName}}</span>
                </a>
                <span class="body-text">{{item.applicantId}} ({{item.approachDisplay}})</span>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-2 body-text">
            <div class="pt-2 d-flex flex-row">
                <div class="determinate-progressbar d-flex pt-2" style="width: 250px;">
                    <div>
                        <label class="text-nowrap">{{item.percentageComplete}}% completed:</label>
                    </div>
                    <div class="w-100">
                        <app-app-progress [roleArtifacts]="item.roleArtifacts"></app-app-progress> 
                    </div>
                </div>
                <div class="determinate-spinner ms-auto mx-3 d-flex flex-row" *ngIf="item.hasExpiry()">
                    <mat-spinner style="width: 30px; height: 30px;"
                        mode="determinate"
                        [value]="item.deadlineRemain*100/item.deadlineTotal">
                    </mat-spinner>
                    <div class="my-auto number"><span [matTooltip]="TOOLTIP.deadlineRemain(item.deadlineRemain)">{{item.deadlineRemain}}</span></div>
                </div>
            </div>
            <div class="pt-2"><span class="body-title">{{item.approachDisplay}} Application: </span><span>{{item.appId}}</span></div>
            <div class="pt-2"><span class="body-title">Originator: </span><span>{{item.originatorFirstName + " " + item.originatorLastName}}</span></div>
            <ng-template *ngTemplateOutlet="dateTemplate"></ng-template> 
        </div>
        <div style="margin-top:10px;">
            <a mat-raised-button color="accent" (click)="redirect(item)">{{appActionText(item.status?.Value || APPLICATION_STATUS.STARTED)}}</a>
        </div>
    </mat-expansion-panel>
</ng-container>

<ng-container *ngIf="applistType == UI_APPLIST_TYPE.aghistory">
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title class="text-nowrap">
                <div class="d-flex justify-content-between col-12 flex-wrap">
                    <div class="mx-2">
                        <mat-icon class="mat-icon-middle material-symbols-outlined mat-icon-size-1">person</mat-icon>
                        <a class="btn">
                            <span class="body-title me-3">{{item.firstName}} {{item.lastName}}</span>
                            <span class="body-text">{{item.applicantId}} ({{item.approachDisplay}})</span>
                        </a>
                    </div>
                    <div class="mx-2">
                        <a class="btn">
                            <span class="body-title me-3">app Id:&nbsp;</span>
                            <span class="body-text">{{item.appId}}</span>
                        </a>
                    </div>
                    <div class="mx-2">
                        <a class="btn">
                            <span class="body-title me-3">Start:&nbsp;</span>
                            <span class="body-text">{{item.startedDate | date:'MM/dd/yyyy'}}</span>
                        </a>
                    </div>
                    <div class="mx-2 mt-1">
                        <div class="determinate-progressbar d-flex pt-1" style="width: 250px;">
                            <div>
                                <label class="text-nowrap">{{item.percentageComplete}}% completed:</label>
                            </div>
                            <div class="w-100">
                                <app-app-progress [roleArtifacts]="item.roleArtifacts"></app-app-progress> 
                            </div>
                        </div>
                    </div>
                    <div class="mx-2 mt-1">
                        <span class="p-2 rounded" [ngClass]="{'badge-bg-danger':item.isActionPending, 'badge-bg-success':!item.isActionPending}">{{ item.status?.Display || 'Started' }}</span>
                    </div>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-2 body-text">
            <div class="pt-2"><span class="body-title">Originator: </span><span>{{item.originatorFirstName + " " + item.originatorLastName}}</span></div>            
        </div>
        <ng-template *ngTemplateOutlet="dateTemplate"></ng-template>
        <div style="margin-top:10px;">
            <a mat-raised-button color="accent" (click)="redirect(item)">{{appActionText(item.status?.Value || APPLICATION_STATUS.STARTED)}}</a>
        </div>
    </mat-expansion-panel>
</ng-container>

<ng-container *ngIf="applistType == UI_APPLIST_TYPE.appactive">
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title class="text-nowrap mx-2">
                <span><mat-icon class="material-symbols-outlined me-1" [ngClass]="{'color-danger':item.isActionPending, 'color-success':!item.isActionPending}">{{item.isActionPending?"error":"check_circle"}}</mat-icon></span>
                <span class="body-title">{{item.approachDisplay}}</span>&nbsp;&nbsp;&nbsp;<span>{{item.appId}}</span>
                <div class="ms-auto"></div>
                <span class="rounded p-2 badge-bg-primary align-top me-2">{{item.status?.Display || 'Started'}}</span>
                <span class="rounded p-2 badge-bg-primary align-top badge-waiting me-1" *ngIf="item.waitingRole">Waiting {{item.waitingRole}}</span>

            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-2 body-text justify-content-between">
            <ng-template *ngTemplateOutlet="dateTemplate"></ng-template>
            <div class="d-flex flex-row">
                <div class="determinate-progressbar d-flex pt-2" style="width: 250px;">
                    <div>
                        <label class="text-nowrap">{{item.percentageComplete}}% completed:</label>
                    </div>
                    <div class="w-100">
                        <app-app-progress [roleArtifacts]="item.roleArtifacts"></app-app-progress> 
                    </div>
                </div>
                <div class="determinate-spinner ms-auto mx-3 d-flex flex-row" *ngIf="item.hasExpiry()">
                    <mat-spinner style="width: 30px; height: 30px;"
                        mode="determinate"
                        [value]="item.deadlineRemain*100/item.deadlineTotal">
                    </mat-spinner>
                    <div class="my-auto number"><span [matTooltip]="TOOLTIP.deadlineRemain(item.deadlineRemain)">{{item.deadlineRemain}}</span></div>
                </div>
            </div>
        </div>
        <div style="margin-top:10px;">
            <a mat-raised-button color="accent" (click)="redirect(item)">{{appActionText(item.status?.Value || APPLICATION_STATUS.STARTED)}}</a>
        </div>
    </mat-expansion-panel>
</ng-container>

<ng-container *ngIf="applistType == UI_APPLIST_TYPE.apphistory">
    <mat-expansion-panel [expanded]="false">
        <mat-expansion-panel-header>
            <mat-panel-title class="text-nowrap mx-2">
                <span class="body-title">{{item.approachDisplay}}</span>&nbsp;&nbsp;&nbsp;<span>{{item.appId}}</span>
                <div class="ms-auto my-3 me-3">
                    <span class="p-2 rounded" [ngClass]="{'badge-bg-danger':item.isActionPending, 'badge-bg-success':!item.isActionPending}">{{ item.status?.Display || 'Started' }}</span>
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="mt-2 body-text">
            <ng-template *ngTemplateOutlet="dateTemplate"></ng-template>
            <div class="determinate-progressbar d-flex pt-2" style="width: 250px;">
                <div>
                    <label class="text-nowrap">{{item.percentageComplete}}% completed:</label>
                </div>
                <div class="w-100">
                    <app-app-progress [roleArtifacts]="item.roleArtifacts"></app-app-progress> 
                </div>
            </div>
        </div>
        <div style="margin-top:10px;">
            <a mat-raised-button color="accent" (click)="redirect(item)">{{appActionText(item.status?.Value || APPLICATION_STATUS.STARTED)}}</a>
        </div>
    </mat-expansion-panel>
</ng-container>

<ng-template #dateTemplate>
    <div class="pt-2">
        Start: <span class="color-light">{{item.startedDate | date:'MM/dd/yyyy'}}</span>
        <ng-container *ngIf="item.hasDeadline()"> | Deadline: <span class="color-light">{{item.deadlineDate | date:'MM/dd/yyyy'}}</span></ng-container>
    </div>
    <div class="pt-2">
        <ng-container *ngIf="item.packageCompleteDate">Submitted: <span class="color-light">{{item.packageCompleteDate | date:'MM/dd/yyyy'}}</span></ng-container>
        <ng-container *ngIf="item.packageCompleteDate && item.decisionDate"> | </ng-container> 
        <ng-container *ngIf="item.decisionDate">Decision: <span class="color-light">{{item.decisionDate | date:'MM/dd/yyyy'}}</span></ng-container>
    </div>
</ng-template>